import React from "react";
import { Foot, Logo, About, Support, FooterLink } from "./footerStyles";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <Foot>
      <Link>
        <Logo>FarmHub</Logo>
      </Link>

      <About>
        <h3>Get to know us</h3>
        <FooterLink to="#">About us</FooterLink>
        <FooterLink to="#">Terms and conditions</FooterLink>
      </About>

      <Support>
        <h3>Support</h3>
        <FooterLink to="#">farmhub@gmail.com</FooterLink>
        <FooterLink to="#">Contact us</FooterLink>
        <FooterLink to="#">FAQ</FooterLink>
      </Support>
    </Foot>
  );
}

export default Footer;
